
import { defineComponent, inject } from 'vue';
import { useCommonDataQuery } from '@/graphql/codegen/generated/graphql';
import { CLOUD_STATUS } from '@/views/settings/settingsCloud/cloud.const';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';
import COLORS from '@/design-system/colors.json';
import incrediIconButton from '../../incrediIconButton.vue';

export default defineComponent({
  name: 'CloudNotifications',
  components: { incrediIconButton },
  setup() {
    const coordinatorsService = inject(IKCoordinatorsService);
    const commonData = useCommonDataQuery(() => ({ coordinatorId: coordinatorsService?.selectedCoordinator.value || '' }));
    return { commonData, CLOUD_STATUS, COLORS };
  },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    cloudStatus() {
      return CLOUD_STATUS[this.commonData?.result?.value?.ibManagerEntities?.settings?.common?.cloud?.cloudStatus as keyof typeof CLOUD_STATUS] || CLOUD_STATUS.Disabled;
    },
    showTooltip() {
      return this.cloudStatus !== CLOUD_STATUS.Deleting && this.cloudStatus !== CLOUD_STATUS.Deactivating && this.cloudStatus !== CLOUD_STATUS.Creating && this.cloudStatus !== CLOUD_STATUS.InProcess;
    },
    attrs() {
      return {
        iconColor: COLORS['Text/Dark'],
        badgeColor: this.badgeColor,
        badgeText: this.badgeText,
      };
    },
    badgeColor() {
      const map: any = {
        Paused: null,
        Enabled: COLORS['Brand/violet'],
        Deleting: COLORS['System/app_warning'],
        Creating: COLORS['System/app_warning'],
        Deactivating: COLORS['System/app_warning'],
        InProcess: COLORS['System/app_warning'],
      };
      return map[this.cloudStatus];
    },
    badgeText() {
      const map: any = {
        Paused: `<i style="color: ${COLORS['Brand/violet']};left: 2.5px;bottom: 2.5px;display: flex; font-size: 20px;position: relative;" class="uis-pause-circle" />`,
        Enabled: '<i style="font-size: 16px; display: flex" class="uil uil-check" />',
        Deleting: '<i style="font-size: 16px; display: flex" class="incredicon-spinner infinite-spinner-animation" />',
        Deactivating: '<i style="font-size: 16px; display: flex" class="incredicon-spinner infinite-spinner-animation" />',
        Creating: '<i style="font-size: 16px; display: flex" class="incredicon-spinner infinite-spinner-animation" />',
        InProcess: '<i style="font-size: 16px; display: flex" class="incredicon-spinner infinite-spinner-animation" />',
      };
      return map[this.cloudStatus];
    },
    getTooltipText() {
      if (this.cloudStatus === CLOUD_STATUS.Paused) {
        return 'Cloud paused';
      }
      if (this.cloudStatus === CLOUD_STATUS.Enabled) {
        return 'Cloud enabled';
      }
      return '';
    },
  },
});
